import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  blogDetailInfo: {},
};

const blogDetailSlice = createSlice({
  name: "blogDetail",
  initialState,
  reducers: {
    setBlogDetailInfo(state, action) {
      state.blogDetailInfo = action.payload;
    },
    clearBlogDetailInfo(state) {
      state.blogDetailInfo = {};
    },
  },
});

export const { setBlogDetailInfo, clearBlogDetailInfo } = blogDetailSlice.actions;
export default blogDetailSlice.reducer;
